import { Marker, Popup } from 'react-leaflet';
import { createLeafletIconFromImage } from '../../utils/mapIcons';

import iconMap from '../../utils/mapIcons'; // Adjust the path as necessary
import { serviceType, serviceTypeDetails } from '../../enum/serviceType';
import StopPopup from '../stop/StopPopup';

function BRTStopMarkers({ stops, userLocation }) {
    const brtService = serviceTypeDetails.find(s => s.type === serviceType.BRT);
    const icon = createLeafletIconFromImage(iconMap.BRT, brtService.color); // or use "BRT" or any other symbol

    return (
        <>
            {stops.map((stop) => (
                <Marker
                    key={stop.stop_id}
                    position={[parseFloat(stop.stop_lat), parseFloat(stop.stop_lon)]}
                    icon={icon}
                >
                    <Popup>
                        <StopPopup stop={stop} userLocation={userLocation}/>
                    </Popup>
                </Marker>
            ))}
        </>
    );
}

export default BRTStopMarkers;
